import { api } from "../lib/axios";

import type { VectorEmbeddingModel } from "../types/vector";
import type { ApiData } from "./apiData";
import type { VectorApiParams } from "./createNamespace";

interface DeleteVectorFileRouteParam {
    fileId: string
}

interface DeleteVectorFileBody {
    embeddingModelName: VectorEmbeddingModel
}

type DeleteVectorFileResponseData = {
    message: 'File deleted'
}

interface DeleteVectorFileResponse extends ApiData<DeleteVectorFileResponseData> {}

async function deleteVectorFile({
    body,
    params,
    routeParam,
}: {
    body: DeleteVectorFileBody
    params: VectorApiParams
    routeParam: DeleteVectorFileRouteParam
}) {
    const response = await api.delete<DeleteVectorFileResponse>(
        `/vector/document/${routeParam.fileId}`,
        { data: body, params }
    )

    return response.data
}

export {
    deleteVectorFile,
    type DeleteVectorFileRouteParam,
    type DeleteVectorFileBody,
    type DeleteVectorFileResponseData,
    type DeleteVectorFileResponse
}